export default __webpack_public_path__ + "static/media/9-min.9f87c1f2.jpg";